import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { Motive } from '../models';

@Injectable()
export abstract class MotivesService {
    /**
     * Persist the provided motive (outside business hours closed tickets).
     */
    abstract createMotive(motive: Motive): Promise<void>;

    /**
     * Delete the provided motive (outside business hours closed tickets).
     */
    abstract deleteMotive(motiveId: string): Promise<void>;

    /**
     * Fetch the motive with provided motive id (outside business hours closed tickets).
     */
    abstract motive(motiveId: string): Promise<Motive | undefined>;

    /**
     * Fetch all motives currently persisted (outside business hours closed tickets).
     */
    abstract motives(): Observable<Motive[]>;

    /**
     * Update the motive with provided motive id with new motive content (outside business hours closed tickets).
     */
    abstract updateMotive(motiveId: string, newMotiveContent: Motive): Promise<void>;
}
